import { z } from "../../wire/zod";

export const canConnectResponseSchema = z.object({ canConnect: z.boolean() });
export const createRallySyncSessionResponseSchema = z.object({ syncSessionId: z.string() });
export const createRallyTestItemResponseSchema = z.object({
  formattedId: z.string(),
  url: z.string(),
});
export const getRallyApiKeyResponseSchema = z.object({ apikey: z.string() });
export const getRallyFieldsResponseSchema = z.object({
  fields: z.array(z.object({ elementName: z.string(), name: z.string() })),
});
export const getRallyIssueTypesResponseSchema = z.object({
  issueTypes: z.array(
    z.object({ elementName: z.string(), displayName: z.string(), id: z.number().int() }),
  ),
});
export const getRallyIterationsResponseSchema = z.object({
  iterations: z.array(
    z.object({ objectId: z.number().int(), name: z.string(), state: z.string() }),
  ),
});
export const getRallyKanbanConfigsResponseSchema = z.object({
  teamConfigs: z.array(
    z.object({ teamId: z.number().int(), configs: z.array(z.record(z.string(), z.any())) }),
  ),
});
export const getRallyPortfolioWorkitemTypesResponseSchema = z.object({
  workitemTypes: z.array(
    z.object({
      elementName: z.string(),
      displayName: z.string(),
      ordinal: z.number().int(),
      typePath: z.string(),
      id: z.number().int(),
    }),
  ),
});
export const getRallyProjectMappingResponseSchema = z.object({
  mapping: z.array(
    z.object({
      userId: z.number().int(),
      sources: z.array(
        z.object({
          projectId: z.number().int(),
          id: z.number().int(),
          name: z.string(),
          defaultFields: z.string().optional(),
        }),
      ),
    }),
  ),
});
export const getRallyProjectsResponseSchema = z.object({
  projects: z.array(z.object({ objectId: z.number().int(), name: z.string() })),
});
export const getRallyReleaseResponseSchema = z.object({
  release: z
    .union([
      z.object({ objectId: z.number().int(), name: z.string(), state: z.string() }),
      z.null(),
    ])
    .optional(),
});
export const getRallyReleasesResponseSchema = z.object({
  releases: z.array(z.object({ objectId: z.number().int(), name: z.string(), state: z.string() })),
});
export const getRallyTagsResponseSchema = z.object({
  tags: z.array(z.object({ objectId: z.number().int(), name: z.string() })),
});
export const getRallyTenantIdResponseSchema = z.object({ tenantId: z.string() });
export const getRallyTenantsResponseSchema = z.object({
  tenants: z.array(z.object({ objectId: z.number().int(), name: z.string() })),
});
export const getRallyWebhooksResponseSchema = z.object({
  webhooks: z.array(
    z.object({
      objectUuid: z.string(),
      name: z.string(),
      targetUrl: z.string(),
      webhookRef: z.string(),
    }),
  ),
});
export const noDataSchema = z.record(z.string(), z.never());
